import { Link } from '@tanstack/react-router'

/** Points founders at the quantitative side, now that it lives on the Share page. */
export function ShareHintBar({ startupId }: { startupId: string }) {
  return (
    <div className="flex items-center gap-2.5 rounded-lg border border-border bg-card2 px-3.5 py-2.5 text-xs text-muted-foreground">
      <span>
        Views, visitors, reading time, and per-page deck analytics moved to{' '}
        <Link
          to="/app/startup/$id/profile/links"
          params={{ id: startupId }}
          className="font-semibold text-primary hover:underline"
        >
          Share your Profile
        </Link>
        . This page keeps what investors think.
      </span>
    </div>
  )
}
